// Make this file a module without importing/exporting anything to prevent Typescript --isolatedModules error
export {};

declare global {
  interface Array<T> {
    forEachAsync: (
      this: Array<T>,
      callbackfn: (value: T, index: number, array: T[]) => Promise<void>,
      thisArg?: any
    ) => Promise<void>;
  }
}

async function forEachAsync<T>(
  this: T[],
  callbackfn: (value: T, index: number, array: T[]) => Promise<void>,
  thisArg?: any[]
) {
  const self = this;

  for (let i = 0; i < self.length; i++) {
    // Order is very important for this, the provided solution from eslint (Promise.all) cannot
    // maintain order with external variables
    // eslint-disable-next-line no-await-in-loop
    await callbackfn(self[i], i, self);
  }
}

/* eslint no-extend-native: ["error", { "exceptions": ["Array"] }] */
Array.prototype.forEachAsync = forEachAsync;
